import { useSelector } from 'react-redux';

import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';

import { COMPARABLE_MONTH_LABEL } from '../../constants';
import type { FlexBuyPaymentFigureField } from '../types';
import { replaceConstantWithTerm } from '../utils';

export const useComparableMonthField = (): FlexBuyPaymentFigureField => {
    const flexBuyPayment = useSelector(offerReduxSelectors.getCurrentFlexBuyPayments);

    const comparableValue = flexBuyPayment?.comparableTermPaymentDetail?.paymentAmount || 0;
    const comparableTerm = flexBuyPayment?.comparableTermPaymentDetail?.term;

    return {
        label: replaceConstantWithTerm({ constantLabel: COMPARABLE_MONTH_LABEL, currentTerm: `${comparableTerm || ''}` }),
        value: formatDollarsAndCents(comparableValue)
    };
};
